import { ITriggerRuleSettingsModel } from '../../interfaces/ITriggerRule';
import { useMutation } from 'react-query';
import { useZoneContext } from '../../contexts/useZoneContext';

export const useCreateTriggerMutation = (onError: (errorMessage: string) => void) => {
    const { zoneApiClient } = useZoneContext();
    return useMutation({
        mutationFn: async (newTrigger: ITriggerRuleSettingsModel) => {
            const response = await zoneApiClient.createTrigger(newTrigger);
            if (!response?.httpResponse.ok) {
                if (response.httpResponse.status === 400
                ) {
                    throw new Error(`Failed to create Trigger : ${response.errorMessage}`);
                }
                else if (response.httpResponse.status === 403
                ) {
                    throw new Error(`Forbidden to create trigger`);
                }
                throw new Error('Failed to create Trigger');
            }
            return response.payload;
        },
        onError(error) {
            if (error instanceof Error) {
                onError(error.message);
            }
        },
    });

}
    